import { AvatarDesignTokens } from '@primeuix/themes/types/avatar';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import { t } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/avatar/index.ts
const av = componentCommon.avatar;

export const AvatarTelekomDT: AvatarDesignTokens = {
  root: {
    width: t(av.width),
    height: t(av.height),
    fontSize: t(av.font.size),
    background: t(av.background),
    color: t(av.color),
    borderRadius: t(av.border.radius),
  },
  icon: {
    size: t(av.icon.size),
  },
  group: {
    borderColor: t(av.group.border.color),
    offset: t(av.group.offset),
  },
  lg: {
    width: t(av.lg.width),
    height: t(av.lg.height),
    fontSize: t(av.lg.font.size),
    icon: { size: t(av.lg.icon.size) },
    group: { offset: t(av.lg.group.offset) },
  },
  xl: {
    width: t(av.xl.width),
    height: t(av.xl.height),
    fontSize: t(av.xl.font.size),
    icon: { size: t(av.xl.icon.size) },
    group: { offset: t(av.xl.group.offset) },
  },
};
